$shm_hitalama_map_page_arrow_widgets $shm_hitalama_map_page_arrow
	from_widget $shm_hitalama_map_widget_float
	to_widget $shm_hitalama_map_widget_float
	from <= from_pos /number
		0
		0
	to <= to_pos /number
		0
		0
